import styled from 'styled-components'
import { padding, PaddingProps } from 'styled-system'
import themeGet from '@styled-system/theme-get'

import { DIV_SHOULD_FORWARD_PROP } from 'Config/shouldForwardProp'

import { LANDING_CONTENT_WIDTH_PX } from 'Constants/Landing'

const shouldForwardProp = (prop: string) =>
  !DIV_SHOULD_FORWARD_PROP.includes(prop)

export const Container = styled.div.withConfig({
  shouldForwardProp,
})<PaddingProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: ${LANDING_CONTENT_WIDTH_PX};
  background-color: ${themeGet('colors.background.screenContrast')};
  gap: 64px;

  ${padding}
`

export const Grid = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: ${themeGet('space.8')}px;
  width: 100%;
`

export const StyledImage = styled.img`
  width: calc((100% - ${themeGet('space.8')}px * 5) / 6);
  min-width: 100px;
  height: 140px;
  object-fit: contain;
  border-radius: 50%;

  @media screen and (min-width: ${themeGet('breakpoints.1')}) {
    height: 160px;
  }
`
